import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M25.89,24.45A1,1,0,0,1,25,25a.93.93,0,0,1-.45-.11L22,23.62V21a1,1,0,0,1,2,0v1.38l1.45.73A1,1,0,0,1,25.89,24.45Z"/><path d="M26,11V7a3,3,0,0,0-3-3H5A3,3,0,0,0,2,7v4Z"/><path d="M26,16.67h0V13L2,13V23a3,3,0,0,0,3,3H16.69A7,7,0,1,0,26,16.67ZM23,28a5,5,0,1,1,5-5A5,5,0,0,1,23,28Z"/><path d="M21,2a1,1,0,0,0-1,1V4h2V3A1,1,0,0,0,21,2Z"/><path d="M8,3A1,1,0,0,0,6,3V4H8Z"/>';
export var CalendarTimeSVG = function CalendarTimeSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CalendarTimeSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CalendarTimeSVG);